import React, { useMemo } from 'react';
import { TPASettingsProviderForModal } from '@wix/tpa-settings/react';
import memoize from 'lodash/memoize';
import { ErrorBoundary } from '../react/ErrorBoundary';
import { useWixSdk } from '../react/SDK/useSDK';
import { WithProviders } from '../react/utils';
import { useBIInstance } from '../SettingsWrapper/hooks/useBIInstance';
import { useI18NextInstance } from '../SettingsWrapper/hooks/useI18NextInstance';
import { getMultilingualLanguageFromQuery } from '../i18next';
import { useHTTPClientInstance } from './hooks/useHTTPClientInstance';
import { useModalExperiments } from './hooks/useModalExperiments';
export var ModalWrapper = function (_a) {
    var biLogger = _a.biLogger, defaultTranslations = _a.defaultTranslations, experimentsConfig = _a.experimentsConfig, localeDistPath = _a.localeDistPath, stylesParams = _a.stylesParams, customCssVars = _a.customCssVars, Modal = _a.Modal, _b = _a.optionalDeps, providers = _b.providers, initI18n = _b.initI18n, createHttpClient = _b.createHttpClient, withStylesHoc = _b.withStylesHoc, createFedopsLogger = _b.createFedopsLogger, sentryConfig = _a.sentryConfig, translationsConfig = _a.translationsConfig;
    var availableProviders = [];
    var Wix = useWixSdk().Wix;
    var experimentsBag = useModalExperiments(experimentsConfig);
    var fedopsLogger = useMemo(function () { return (createFedopsLogger && Wix ? createFedopsLogger(Wix) : null); }, [Wix, createFedopsLogger]);
    var _c = providers, BILoggerProvider = _c.BILoggerProvider, ExperimentsProvider = _c.ExperimentsProvider, FedopsLoggerProvider = _c.FedopsLoggerProvider, I18nextProvider = _c.I18nextProvider, HttpProvider = _c.HttpProvider;
    var biInstance = useBIInstance({
        biLogger: biLogger,
        Wix: Wix,
    });
    var language = getMultilingualLanguageFromQuery() || (Wix === null || Wix === void 0 ? void 0 : Wix.Utils.getLocale()) || 'en';
    var i18NextInstance = useI18NextInstance({
        defaultTranslations: defaultTranslations,
        initI18n: initI18n,
        language: language,
        localeDistPath: localeDistPath,
        translationsConfig: translationsConfig,
    });
    var httpClientInstance = useHTTPClientInstance({ createHttpClient: createHttpClient });
    if (i18NextInstance) {
        availableProviders.push(function (children) {
            return (React.createElement(I18nextProvider, { i18n: i18NextInstance }, children));
        });
    }
    if (sentryConfig) {
        availableProviders.push(function (children) {
            return (React.createElement(ErrorBoundary, { handleException: window.Sentry.captureException, configure: function () { } }, children));
        });
    }
    else {
        availableProviders.push(function (children) { return (React.createElement(ErrorBoundary, { handleException: console.log }, children)); });
    }
    if (fedopsLogger) {
        availableProviders.push(function (children) { return (React.createElement(FedopsLoggerProvider, { value: fedopsLogger }, children)); });
    }
    if (biInstance) {
        availableProviders.push(function (children) {
            return Wix ? (React.createElement(BILoggerProvider, { logger: biInstance }, children)) : (children);
        });
    }
    if (experimentsConfig) {
        availableProviders.push(function (children) {
            return (React.createElement(ExperimentsProvider, { experiments: experimentsBag }, children));
        });
    }
    if (HttpProvider && httpClientInstance) {
        availableProviders.push(function (children) {
            return (React.createElement(HttpProvider, { client: httpClientInstance }, children));
        });
    }
    if (Wix) {
        availableProviders.push(function (children) { return (React.createElement(TPASettingsProviderForModal, { Wix: Wix, language: language }, children)); });
    }
    if (!withStylesHoc) {
        throw new Error('withStyles HOC have not been passed, please report this to Yoshi team');
    }
    var ModalWithStylesComponent = withStylesHoc(Modal, {
        defaults: stylesParams !== null && stylesParams !== void 0 ? stylesParams : undefined,
        customCssVars: customCssVars,
        enableMemoization: typeof WeakMap === 'undefined' || memoize.Cache !== WeakMap,
    });
    var ModalComponent = function () {
        var styleObject = React.useMemo(function () {
            if (!Wix) {
                return null;
            }
            return {
                siteColors: Wix.Styles.getSiteColors(function (c) { return c; }) || [],
                siteTextPresets: Wix.Styles.getSiteTextPresets(function (t) { return t; }) || {},
                styleParams: Wix.Styles.getStyleParams(function (p) { return p; }),
            };
        }, [Wix]);
        if (!styleObject) {
            return null;
        }
        return (React.createElement(ModalWithStylesComponent, { host: { style: styleObject } }));
    };
    return (React.createElement(WithProviders, { providers: availableProviders },
        React.createElement(ModalComponent, null)));
};
//# sourceMappingURL=ModalWrapper.js.map